module.exports = __webpack_public_path__ + "img/kanban.d34db913.png";